// 2023 Topps Star Wars NYCC Sparkle Packs — authored by hand (2026-08-30)
// =============================================================================
// Source: Trader Cracks' "2023 Topps Star Wars NYCC Sparkle Packs" checklist,
// spot-checked against TCDB and COMC (SWBNY-9 Padmé Amidala confirmed on both).
// 20 cards of 2023 flagship imagery with sparkle-foil borders, four cards per
// pack, one pack per 2023 High Tek box bought at the Topps booth at New York
// Comic Con (October 12–15, 2023). The default card is an UNNUMBERED Silver
// Sparkle (so no base serial slot — rule 7 doesn't apply), with five numbered
// variants: Blue Sparkle /75, Gold Sparkle /50, Orange Sparkle /25, Red
// Sparkle /5 and the FoilFractor 1/1. The plain white-bordered SWNY giveaway
// cards are a separate CK set (2023-nycc).
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "blue-sparkle", name: "Blue Sparkle", print_run: 75, color: "#2979ff" },
        { id: "gold-sparkle", name: "Gold Sparkle", print_run: 50, color: "#f0c040" },
        { id: "orange-sparkle", name: "Orange Sparkle", print_run: 25, color: "#ff9100" },
        { id: "red-sparkle", name: "Red Sparkle", print_run: 5, color: "#ff1744" },
        { id: "foilfractor", name: "FoilFractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SWBNY-1", name: "Finn – Star Wars: The Rise of Skywalker" },
        { n: "SWBNY-2", name: "Hera Syndulla – Star Wars: The Bad Batch" },
        { n: "SWBNY-3", name: "Han Solo – Star Wars: A New Hope" },
        { n: "SWBNY-4", name: "Princess Leia – Obi-Wan Kenobi" },
        { n: "SWBNY-5", name: "Grogu – The Mandalorian" },
        { n: "SWBNY-6", name: "Darth Vader – Obi-Wan Kenobi" },
        { n: "SWBNY-7", name: "Yoda – Star Wars: The Last Jedi" },
        { n: "SWBNY-8", name: "Rey – Star Wars: The Force Awakens" },
        { n: "SWBNY-9", name: "Padmé Amidala – Star Wars: The Phantom Menace" },
        { n: "SWBNY-10", name: "Chewbacca – Star Wars: A New Hope" },
        { n: "SWBNY-11", name: "C-3PO – Star Wars: A New Hope" },
        { n: "SWBNY-12", name: "R2-D2 – Star Wars: A New Hope" },
        { n: "SWBNY-13", name: "Darth Maul – Star Wars: The Phantom Menace" },
        { n: "SWBNY-14", name: "Mace Windu – Star Wars: The Phantom Menace" },
        { n: "SWBNY-15", name: "Emperor Palpatine – Star Wars: Return of the Jedi" },
        { n: "SWBNY-16", name: "Kuiil – The Mandalorian" },
        { n: "SWBNY-17", name: "B2EMO – Andor" },
        { n: "SWBNY-18", name: "Tam Ryvora – Star Wars Resistance" },
        { n: "SWBNY-19", name: "Ezra Bridger – Star Wars Rebels" },
        { n: "SWBNY-20", name: "The Armorer – The Mandalorian" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// The base sub-set above declares its own array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
